import React from 'react';
import styled from 'styled-components';
import { FaInstagram, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const ContactSection = styled.section`
  padding: 6rem 2rem 4rem;
  background-color: var(--dark-gray);
`;

const SectionTitle = styled.h2`
  font-family: 'Blackwood Castle', serif;
  font-size: 3rem;
  color: var(--gold);
  text-align: center;
  margin-bottom: 3rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
`;

const ContactContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 3rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const ContactInfo = styled.div`
  width: 100%;
  max-width: 500px;
  background-color: var(--royal-blue);
  border: 2px solid var(--gold);
  border-radius: 5px;
  padding: 2rem;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: -5px;
    left: -5px;
    right: -5px;
    bottom: -5px;
    border: 1px solid var(--gold);
    pointer-events: none;
    opacity: 0.5;
    z-index: 1;
    border-radius: 8px;
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
`;

const ContactIcon = styled.div`
  font-size: 1.5rem;
  color: var(--gold);
  margin-right: 1rem;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--gold);
  border-radius: 50%;
`;

const ContactText = styled.div`
  flex: 1;
`;

const ContactLabel = styled.h4`
  font-family: 'Blackwood Castle', serif;
  font-size: 1.2rem;
  color: var(--gold);
  margin-bottom: 0.25rem;
`;

const ContactValue = styled.p`
  color: var(--white);
  font-size: 1rem;
`;

const ContactLink = styled.a`
  color: var(--white);
  transition: color 0.3s ease;
  
  &:hover {
    color: var(--gold);
  }
`;

const MapContainer = styled.div`
  width: 100%;
  max-width: 500px;
  height: 400px;
  border: 2px solid var(--gold);
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: -5px;
    left: -5px;
    right: -5px;
    bottom: -5px;
    border: 1px solid var(--gold);
    pointer-events: none;
    opacity: 0.5;
    z-index: 1;
    border-radius: 8px;
  }

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;

const SocialContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 3rem;
`;

const SocialLink = styled.a`
  font-size: 2rem;
  color: var(--gold);
  margin: 0 1rem;
  transition: transform 0.3s ease, color 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    color: var(--gold);
  }
`;

const Contact = () => {
  return (
    <ContactSection id="contact">
      <SectionTitle>Nous Trouver</SectionTitle>
      <ContactContainer>
        <ContactInfo>
          <ContactItem>
            <ContactIcon>
              <FaMapMarkerAlt />
            </ContactIcon>
            <ContactText>
              <ContactLabel>Adresse</ContactLabel>
              <ContactValue>33 Rue de Cléry, 75002 Paris</ContactValue>
            </ContactText>
          </ContactItem>
          
          <ContactItem>
            <ContactIcon>
              <FaPhone />
            </ContactIcon>
            <ContactText>
              <ContactLabel>Téléphone</ContactLabel>
              <ContactValue>
                <ContactLink href="tel:0142360774">01 42 36 07 74</ContactLink>
              </ContactValue>
            </ContactText>
          </ContactItem>
          
          <ContactItem>
            <ContactIcon>
              <FaEnvelope />
            </ContactIcon>
            <ContactText>
              <ContactLabel>Email</ContactLabel>
              <ContactValue>
                <ContactLink href="mailto:loveyourskinparis2@gmail.com">loveyourskinparis2@gmail.com</ContactLink>
              </ContactValue>
            </ContactText>
          </ContactItem>
          
          <ContactItem>
            <ContactIcon>
              <FaInstagram />
            </ContactIcon>
            <ContactText>
              <ContactLabel>Instagram</ContactLabel>
              <ContactValue>
                <ContactLink href="https://instagram.com/love_your_skin_paris" target="_blank" rel="noopener noreferrer">
                  @love_your_skin_paris
                </ContactLink>
              </ContactValue>
            </ContactText>
          </ContactItem>
        </ContactInfo>
        
        <MapContainer>
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2624.4861376295363!2d2.3432233!3d48.8687755!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66e3ed2f8f98d%3A0x5c0f3d8e7f8a3a0!2s33%20Rue%20de%20Cl%C3%A9ry%2C%2075002%20Paris%2C%20France!5e0!3m2!1sen!2sus!4v1621436289012!5m2!1sen!2sus" 
            allowFullScreen="" 
            loading="lazy"
            title="Love Your Skin Location"
          />
        </MapContainer>
      </ContactContainer>
      
      <SocialContainer>
        <SocialLink href="https://instagram.com/love_your_skin_paris" target="_blank" rel="noopener noreferrer">
          <FaInstagram />
        </SocialLink>
      </SocialContainer>
    </ContactSection>
  );
};

export default Contact;
